import { render, staticRenderFns } from "./AmazonDisplay.vue?vue&type=template&id=0d8689dc&scoped=true&lang=pug"
import script from "./AmazonDisplay.js?vue&type=script&lang=js&external"
export * from "./AmazonDisplay.js?vue&type=script&lang=js&external"
import style0 from "./AmazonDisplay.sass?vue&type=style&index=0&id=0d8689dc&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8689dc",
  null
  
)

export default component.exports